import React, { useState, useEffect } from "react";
import TweetReviewer from "./components/TweetReviewer";
import Stats from "./components/Stats";
import "./App.css";

function App() {
  const [currentTweet, setCurrentTweet] = useState(null);
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState("");
  const [sortOrder, setSortOrder] = useState("latest");

  const fetchNextTweet = async (order = sortOrder) => {
    try {
      setLoading(true);
      const response = await fetch(`/api/tweets/next?order=${order}`);
      const data = await response.json();

      if (data.message) {
        setCurrentTweet(null);
        setMessage(data.message);
      } else {
        setCurrentTweet(data);
        setMessage("");
      }
    } catch (error) {
      console.error("Error fetching tweet:", error);
      setMessage("Error al cargar el tweet");
    } finally {
      setLoading(false);
    }
  };

  const fetchStats = async () => {
    try {
      const response = await fetch("/api/stats");
      const data = await response.json();
      setStats(data);
    } catch (error) {
      console.error("Error fetching stats:", error);
    }
  };

  const handleAction = async (action) => {
    if (!currentTweet) return;

    try {
      setLoading(true);
      const response = await fetch(`/api/tweets/${currentTweet.id}/status`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ status: action }),
      });

      if (response.ok) {
        await fetchNextTweet();
        await fetchStats();
      } else {
        setMessage("Error al actualizar el tweet");
        setLoading(false);
      }
    } catch (error) {
      console.error("Error updating tweet:", error);
      setMessage("Error al actualizar el tweet");
      setLoading(false);
    }
  };

  const handleSortOrderChange = (newOrder) => {
    setSortOrder(newOrder);
    fetchNextTweet(newOrder);
  };

  useEffect(() => {
    fetchNextTweet();
    fetchStats();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="app">
      <header className="app-header">
        <h1>Revisión de Tweets</h1>
        <p>Plataforma colaborativa para revisar tweets scrapeados</p>
        <div className="sort-controls">
          <label>Ordenar por: </label>
          <select
            value={sortOrder}
            onChange={(e) => handleSortOrderChange(e.target.value)}
            className="sort-selector"
          >
            <option value="oldest">ID más bajo primero (más antiguos)</option>
            <option value="latest">ID más alto primero (más recientes)</option>
          </select>
        </div>
      </header>

      <main className="app-main">
        {stats && <Stats stats={stats} />}

        {loading ? (
          <div className="loading">Cargando...</div>
        ) : message ? (
          <div className="message">{message}</div>
        ) : currentTweet ? (
          <TweetReviewer tweet={currentTweet} onAction={handleAction} />
        ) : null}
      </main>
    </div>
  );
}

export default App;
